import { ImageUp, LibraryBig, Loader } from "lucide-react";
import { Button } from "primereact/button";

interface Props {
  uploading?: boolean;
  onSelect?: () => void;
  onUpload?: () => void;
}

export default function ImageSelector({
  uploading,
  onSelect,
  onUpload,
}: Props) {
  return (
    <div className="relative flex h-full min-h-32 w-full flex-1 flex-col items-center justify-center gap-2 overflow-hidden rounded border border-dashed border-gray-300">
      <div className="absolute inset-0 cursor-pointer" onClick={onSelect}></div>
      <div className="flex items-end justify-center gap-4">
        <Button
          style={{ width: 36, height: 36 }}
          type="button"
          icon={<ImageUp />}
          tooltip="Upload"
          tooltipOptions={{ position: "top" }}
          onClick={onUpload}
        />
        <Button
          severity="info"
          type="button"
          style={{ width: 36, height: 36 }}
          icon={<LibraryBig />}
          tooltip="Select from library"
          tooltipOptions={{ position: "top" }}
          onClick={onSelect}
        />
      </div>
      <div className="flex cursor-pointer flex-col items-center px-2 text-center text-sm text-gray-500">
        {uploading ? "Uploading ..." : "Upload or select from library"}
      </div>
      {uploading && (
        <div className="absolute inset-0 flex h-full w-full items-center justify-center bg-gray-300 opacity-50">
          <Loader className="animate-spin" />
        </div>
      )}
    </div>
  );
}
